var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"footbar",attrs:{"padless":""}},[_c('v-card-text',{staticClass:"white--text"},[_vm._v(" © "+_vm._s(new Date().getFullYear())+" Capita Business Services Ltd. All rights reserved.")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }